export default class GoogleAnalytics {

    constructor() {

        this.params = {
            js: new Date,
            config: document.head.querySelector('meta[name="google-analytics-id"]').content,
        };

        this.initialize();
    }

    initialize() {
        window.dataLayer = window.dataLayer || [];
        this.addECommerceParams();
        window.dataLayer.push(this.params);
    }

    addECommerceParams() {
        let data = document.head.querySelector('meta[name="ecommerce-data"]').content;
        if (!data) {
            return;
        }
        this.params = Object.assign({}, this.params, JSON.parse(data));
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/src/core/GoogleAnalytics.js